export default {
	googleApiGeocode: "AIzaSyAuNDdmifjszzBXyNe_zCSTOXVIhlbZar0",
	googleClientID: "925135419069-p3angg84e71ek89gkf8043982npj2n8h.apps.googleusercontent.com",
	facebookAppID: "1195045194266769"
};
